module.exports = __webpack_public_path__ + "static/img_2426-1307d3a8697dfcdb88e975a0b630dbb1.webp";